import React from 'react'

const VendorCredits = () => {
  return (
    <div>VendorCredits</div>
  )
}

export default VendorCredits